var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #414042;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: #b4bbbf;\n      }\n\n      .cls-6 {\n        fill: #9fa4a6;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #cbba73;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 232.5091,
    y1: 101.0757,
    x2: 346.8237,
    y2: 101.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 177.9361,
    y1: 150.0025,
    x2: 177.9361,
    y2: 177.2216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecb488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fccc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 205.3362,
    y1: 101.5496,
    x2: 160.0016,
    y2: 114.0557,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 21.014,
    y: 58.5044,
    width: 304.9631,
    height: 221.971,
    rx: 3.6375,
    ry: 3.6375
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.3399,283.371H24.6511c-3.6025,0-6.5345-2.9298-6.5345-6.5324V62.1426c0-3.6025,2.9319-6.5345,6.5345-6.5345h297.6888c3.6025,0,6.5345,2.9319,6.5345,6.5345v214.696c0,3.6025-2.9319,6.5324-6.5345,6.5324ZM24.6511,61.4007c-.4024,0-.7419.3395-.7419.7419v214.696c0,.4003.3395.7398.7419.7398h297.6888c.4024,0,.7419-.3395.7419-.7398V62.1426c0-.4024-.3395-.7419-.7419-.7419H24.6511Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.7665,
    y: 30.0875,
    width: 169.4582,
    height: 266.3333,
    transform: "translate(336.7496 -10.2414) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.5581,250.879H37.4329V75.6286h272.1252v175.2504ZM43.2255,245.0864h260.54V81.4211H43.2255v163.6653Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.9181,266.2239v30.0724c0,3.1439-2.5527,5.7161-5.6727,5.7161H11.7456c-3.12,0-5.6727-2.5722-5.6727-5.7161v-30.0724h122.1337v7.223c0,1.429,1.1603,2.5982,2.5785,2.5982h85.4209c1.4182,0,2.5785-1.1692,2.5785-2.5982v-7.223h122.1337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.2453,304.9087H11.7457c-4.7259,0-8.5694-3.8645-8.5694-8.6134v-32.9678h127.927v9.8205h84.7845v-9.8205h127.927v32.9678c0,4.7489-3.8436,8.6134-8.5694,8.6134ZM8.9689,269.1201v27.1752c0,1.555,1.247,2.8208,2.7768,2.8208h323.4997c1.5299,0,2.7768-1.2658,2.7768-2.8208v-27.1752h-116.3418v4.3277c0,3.0283-2.4562,5.4929-5.474,5.4929h-85.4216c-3.0178,0-5.474-2.4646-5.474-5.4929v-4.3277H8.9689Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.3833,45.0913h-81.4116c-9.0433,0-16.4627,7.3968-16.4627,16.4627v57.2812c0,8.7953,7.0135,16.0568,15.741,16.4403v21.7848l25.1678-21.7623h56.9655c9.0432,0,16.4404-7.4195,16.4404-16.4628v-57.2812c0-9.0659-7.3972-16.4627-16.4404-16.4627Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.7786,
    y: 75.6096,
    width: 81.4607,
    height: 9.5524
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 250.7786,
    y: 95.7757,
    width: 66.8668,
    height: 9.5524
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "228.2563 193.2176 127.5825 193.2176 133.8883 113.2212 134.9149 99.6564 220.9239 99.6564 223.1235 127.5929 228.2563 193.2176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.6977,234.5004c0,3.7029-.2863,7.3397-.8152,10.8661H110.9861c-.5291-3.5264-.7936-7.1632-.7936-10.8661,0-30.548,18.6241-56.5339,44.6983-66.3418,7.1852-2.689,14.9215-4.1657,23.0102-4.1657,37.4689,0,67.7967,31.5621,67.7967,70.5075Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.8948,173.7003l23.0414-50.3774,23.0414,50.3774s-8.0153,16.7289-23.0414,16.7289-23.0414-16.7289-23.0414-16.7289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.9973,102.1492c0,.5133,0,1.0266-.0734,1.54-.1468,5.4259-1.3198,11.2917-3.2263,17.0842-6.4526,19.7242-21.8504,39.0818-39.7415,39.0818-20.8976,0-38.3488-26.1767-42.2347-48.6139-.4399-2.5662-.7335-5.1328-.8065-7.5521-.0734-.5133-.0734-1.0266-.0734-1.54s0-1.0266.0734-1.4666c0-.3665,0-.7331.0729-1.0262-.0729-.5867,0-1.1734.0734-1.6868.4399-4.3259,1.4666-8.432,3.0799-12.3184,6.3792-15.6181,21.777-26.6167,39.8149-26.6167,20.3839,0,37.3951,14.1515,41.8677,33.216.2936,1.173.5133,2.3464.6601,3.5928v.0734c.2197,1.173.3665,2.4194.3665,3.7396.0734.2931.0734.6597.0734,1.0262.0734.4399.0734.9532.0734,1.4666Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M220.484,95.8434v.0734c-4.6928,1.5395-9.0921,2.3464-12.9051,3.7396-15.9112,5.719-26.1767,2.5662-34.0959,0-.5129-.2202-.9532-.367-1.4661-.5133-10.8523-3.5199-17.3048-9.7522-29.1833-5.2062-2.3464.8799-4.9126,2.1996-7.7723,4.0327.4399-4.3259,1.4666-8.432,3.0799-12.3184,6.3792-15.6181,21.777-26.6167,39.8149-26.6167,20.3839,0,37.3951,14.1515,41.8677,33.216.2936,1.173.5133,2.3464.6601,3.5928Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.0804,93.2039c-.367.1463-.8069.3665-1.2468.7331-1.3932,1.173-2.8593,3.2263-4.1061,5.7195-1.7597,3.446-3.1529,7.7723-3.0061,11.5849.0734.2202.0734.4399.0734.6601l-1.9065,1.3198,1.0266-13.5648h.0729c-.0729-.5867,0-1.1734.0734-1.6868.4399-4.3259,1.4666-8.432,3.0799-12.3184,3.0061,2.1996,8.432,6.5993,5.9392,7.5526Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M223.1235,127.5929c-3.2263.5129-5.9392-.2202-5.5727-4.8396.0734-.6597.0734-1.3198.1468-1.9799.5867-9.2385-.2931-19.9439-7.6989-21.1169-.7335-.0734-1.54-.0734-2.4198,0l.2202-4.5465,9.0187-3.8125,3.0061.9532c.2936,1.173.5133,2.3464.6601,3.5928v.0734c.2197,1.173.3665,2.4194.3665,3.7396h.0734l2.1996,27.9364Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.8908,168.1585v77.2079h-43.9047c-.5291-3.5264-.7936-7.1632-.7936-10.8661,0-30.548,18.6241-56.5339,44.6983-66.3418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.9814,168.1585v77.2079s43.9047,0,43.9047,0c.5291-3.5264.7936-7.1632.7936-10.8661,0-30.548-18.6241-56.5339-44.6983-66.3418Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.1db5adb6e30581a8e5168805c87f764b.svg";
export { ForwardRef as ReactComponent };